module.exports = __webpack_public_path__ + "assets/media/lunch.576a8839.mp3";